<template>
  <div v-show="displayFrontend" :class="{questions__save: safeFreeze}" class="questions">
    <h1 class="questions__header">{{ $t("Overtime") }}</h1>
    <h2 class="questions__subheader">{{
        $t("Overtime is calculated for fixed contract types based on the remuneration timeframe and base selected. By default, the additional hours are settled with the TFT balance. You can then decide when you pay out part of the accrued TFT. It is also possible to have overtime paid out automatically. When paying automatically, it is possible to make a distinction between overtime and overtime hours. Extra hours are the hours between a part-time contract and the full-time working week. Overtime are the hours above the full-time limit.")
      }}</h2>
    <b-form-group :label="$t('How do you handle overtime?')">
      <b-form-radio v-model="overtime.overtimePay" class="fit-content" name="plusHours" value="plusHoursTfT">
        {{ $t("All plus hours to TFT balance") }}
      </b-form-radio>
      <b-form-radio v-model="overtime.overtimePay" v-b-popover.hover.right="$t('Only recommended in combination on a period based on weeks: week / 4-weeks / 445 (see previous page).')" class="fit-content" name="plusHours"
                    value="payOvertimeTfTPlusHours">
        {{ $t("Pay plus hours, transfer overtime hours to TFT balance") }}
      </b-form-radio>
      <b-form-radio v-model="overtime.overtimePay" v-b-popover.hover.right="$t('Only recommended in combination on a period based on weeks: week / 4-weeks / 445 (see previous page).')" class="fit-content" name="plusHours"
                    value="payOvertimePayPlusHours">
        {{ $t("Payout both plus and overtime hours") }}
      </b-form-radio>
      <b-form-radio v-model="overtime.overtimePay" class="fit-content" name="plusHours" value="overtimeManualPlusHoursPay">
        {{ $t("Overtime: determine per employee per period. Plus hours: pay") }}
      </b-form-radio>
      <b-form-radio v-model="overtime.overtimePay" class="fit-content" name="plusHours" value="overtimeManualPlusHoursTft">
        {{ $t("Overtime: determine per employee per period. Plus hours: TFT balance") }}
      </b-form-radio>
      <b-form-radio v-model="overtime.overtimePay" class="fit-content" name="plusHours" value="overtimeManualPlusHoursManual">
        {{ $t("Overtime: determine per employee per period. Plus hours: determine per employee per period") }}
      </b-form-radio>
    </b-form-group>

    <h2 class="questions__subheader">{{ $t("Other overtime rules") }}</h2>
    <b-form-textarea
      v-model="overtime.overtimePayNotes"
      class="questions__textarea"
      rows="3"></b-form-textarea>

    <h2 class="questions__subheader">
      {{ $t("Do you want to pay out TFT hours if the balance exceeds a certain number of hours?") }}</h2>

    <b-form-checkbox
      v-model="tftPayout"
      name="check-button"
      switch
      @change="overtime.tftPayoutThreshold=''">
      {{ $t("Yes, we pay overtime above a threshold") }}
    </b-form-checkbox>

    <div v-show="tftPayout">
      <h2 class="questions__subheader">{{ $t("Pay out above how many hours?") }}</h2>
      <input
        v-model="overtime.tftPayoutThreshold"
        class="form-control"
        min="0"
        type="number"
      />
    </div>

    <h2 class="questions__subheader">
      {{ $t("Do you want to display warnings related to the working hours act?") }}</h2>

    <b-form-checkbox
      v-model="overtime.workingHoursActWarning"
      name="check-button"
      switch>
      {{ $t("Yes, we want to see warnings when the working hours act is exceeded") }}
    </b-form-checkbox>

    <h2 class="questions__subheader">{{ $t("Remarks") }}</h2>
    <b-form-textarea
      v-model="overtime.remarks"
      class="questions__textarea"
      rows="3"/>

    <input :value="$t('Save')" type="button" @click="handleSave"/>
    <p v-show="showSaveStatus" class="questions--savesuccess">{{ $t("Saved successfully!") }}</p>
  </div>
</template>

<script>
import SystemRequestService from "@/SystemRequestService";
import GlobalFunctions from "@/GlobalFunctions";

export default {
  name: "Overtime",
  data() {
    return {
      displayFrontend: false,
      safeFreeze: false,
      showSaveStatus: false,
      tftPayout: false,
      overtime: {
        overtimePay: null,
        overtimePayNotes: null,
        tftPayoutThreshold: null,
        workingHoursActWarning: false,
        remarks: null,
      }
    };
  },
  async beforeMount() {
    const result = await SystemRequestService.getProject(this.$route.params.hashedId);
    if (!result) {
      alert(this.$t("Error while obtaining your details. Please try again later or contact your Dyflexis consultant."));
      return;
    }

    if (result.overtime !== null) {
      let overtimeDecoded;
      try {
        overtimeDecoded = JSON.parse(result.overtime.replaceAll("&quot;", '"'));
      } catch (e) {
        this.displayFrontend = true;
        return false;
      }
      this.overtime = overtimeDecoded;

      if (this.overtime.tftPayoutThreshold !== null && this.overtime.tftPayoutThreshold !== '') {
        this.tftPayout = true;
      }
    }

    GlobalFunctions.setReadOnly(result.isSigned);
    localStorage.setItem('startingObject', JSON.stringify(this.overtime));
    this.displayFrontend = true;
  },
  beforeRouteLeave: function (to, from, next) {
    if (!GlobalFunctions.acceptPageLeave(this.overtime, this.$t("You have made changes without saving them. Press cancel to ignore these changes and leave the page."))) {
      this.handleSave(false);
    }
    next();
  },
  methods: {
    async handleSave(saveInitialObject) {
      this.safeFreeze = true;
      const result = await SystemRequestService.updateProject(this.overtime, this.$route.params.hashedId);
      if (!result || result.status !== 'success') {
        alert(this.$t("Error while updating, please send a screenshot of the fields on this page to your Dyflexis consultant!"));
        return;
      }

      if (saveInitialObject !== false) {
        localStorage.setItem('startingObject', JSON.stringify(this.overtime));
      }

      this.safeFreeze = false;
      this.showSaveStatus = true;
      setTimeout(() => {
        this.showSaveStatus = false;
      }, 3000);
    },
  }
};
</script>
